import React from 'react';

import { BRAND_COLORS } from 'brand-guidelines/colors';

interface InfoCircleSvgProps {
  color?: string;
  className?: string;
}

// Hand-optimized tabler info-circle SVG

export const InfoCircleSvg = ({
  color = BRAND_COLORS.darkStroke,
  className,
}: InfoCircleSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    fill="none"
    stroke={color}
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    className={className}
  >
    <circle cx="8" cy="8" r="7" />
    <path d="M8.19 5.667h.008" />
    <path d="M7.412 8h.778v3.111h.778" />
  </svg>
);

